const International = {
  subtitlo: {
    sub1: {
      en : 'Call Girls',
      es : 'Prepagos',
    },
    sub2: {
      en: 'Companions',
      es: 'Damas de Compañía',
    },
    sub3: {
      en : 'Escorts',
      es : 'Escorts',
    },
    sub4: {
      en: 'Best Escorts',
      es: 'Mejores Escorts'
    },
    sub5: {
      en : 'Do you have especials requirements?',
      es : '¿ Quieres encontrar tu modelo ideal ?',
    },
    sub6: {
      en: 'Try this form and find the best match',
      es: 'Prueba navegar de acuerdo a tus preferencias en los enlaces del frente',
    },
    sub7: {
      en: ' from Bogotá, Cartagena, Cali y Medellín; Call Girls, whores and ',
      es: ' y prepagos de Bogotá, Cartagena, Cali y Medellín; Call Girls, Putas y ',
    }
  },
  // Consent Modal Translations
  texts: {
  older: {
    en: 'Are you 18 or older?',
    es: 'Tienes 18 años o más?',
  },
  services: {
    en:
      'We are providing video calling services during the lock down. You must specify that you are 18 years of age or older to use this site',
    es:
      'Estamos ofreciendo servicio de video llamadas durante la cuarentena. Debe especificar que tiene 18 años de edad o más para usar este sitio.',
  },
  yes: {
    en: 'Yes',
    es: 'Sí',
  },
  no: {
    en: 'No',
    es: 'No',
  },
}
};

export default International;